// "Hoy" en fecha LOCAL, como YYYY-MM-DD.
//
// NUNCA usar `new Date().toISOString().slice(0, 10)` para esto: toISOString
// convierte a UTC primero, y como Guatemala está en UTC-6, a partir de las
// 18:00 hora local esa fecha ya cae en el día siguiente en UTC. El backend
// usa CURDATE() (fecha del servidor, en su zona local) para filtrar "hoy",
// así que un frontend que manda la fecha de mañana después de las 6pm
// termina sin encontrar nada — parece un problema de la base de datos pero
// es este desfase de zona horaria.
export function hoyLocal() {
  const ahora = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${ahora.getFullYear()}-${pad(ahora.getMonth() + 1)}-${pad(ahora.getDate())}`;
}

// Convierte una fecha YYYY-MM-DD (o cualquier string que empiece así) a DD/MM/YYYY para mostrar en pantalla.
export function formatearFechaDisplay(fecha) {
  if (!fecha) return '';
  const [anio, mes, dia] = String(fecha).slice(0, 10).split('-');
  return `${dia}/${mes}/${anio}`;
}

// Año + número de semana ISO (lunes a domingo) de hoy, como valor listo
// para un <input type="week"> (formato "YYYY-Www"). Mismo cálculo que
// calcularSemanaISO en el backend, para que "semana actual" coincida
// en frontend y backend.
export function semanaActualISO() {
  const hoy = new Date();
  const objetivo = new Date(hoy.valueOf());
  const diaSemana = (hoy.getDay() + 6) % 7;
  objetivo.setDate(objetivo.getDate() - diaSemana + 3);
  const primerJueves = new Date(objetivo.getFullYear(), 0, 4);
  const diff = objetivo - primerJueves;
  const semana = 1 + Math.round(diff / (7 * 24 * 60 * 60 * 1000));
  return `${objetivo.getFullYear()}-W${String(semana).padStart(2, '0')}`;
}
